// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "ul.dropdown-menu li[data-v-79f1bbec]{margin-left:8px;color:#000}.email-content[data-v-79f1bbec]{padding:10px 10px;margin:0 0 10px;font-size:12.5px;border-left:5px solid #eee}", ""]);
// Exports
module.exports = exports;
